import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle `
    :root {
        ${(props) => props.theme.breakpoints
    .map((bp, index) => {
    if (index === 0)
        return `font-size: ${props.theme.rootFontSizes[index]};`;
    return `@media (min-width: ${bp}px) {font-size: calc(${props.theme.rootFontSizes[index]});}`;
})
    .join('\n')}
    }

    html {
        box-sizing: border-box;
    }

    *, *:before, *:after {
        box-sizing: inherit;
    }

    body {
        background-color: ${(props) => props.theme.colors.background};
        color: ${(props) => props.theme.colors.text};
        transition: background 0.3s;
        margin: 0;
        height: 100vh;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: ${(props) => props.theme.sizes['0']};
        line-height: normal;
        font-variant-numeric: tabular-nums;
    }

    a {
        text-decoration: none;
        color: ${(props) => props.theme.colors.link};

        &:hover {
            color: ${(props) => props.theme.colors.linkHover};
        }
    }

    p {
        margin: 0;
    }

    @keyframes loading-skeleton-animation {
      100% {
        transform: translateX(100%);
      }
    }
`;

export { GlobalStyle as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
